<template>
    <ActionModal class="ConfirmModal" @close="close">
        <template #title>
            {{ title }}
        </template>

        <template #default>
            <div>
                <p>{{ message }}</p>
            </div>
        </template>

        <template #footer>
            <div class="flex space-x-4">
                <CButton class="w-1/2 uppercase" size="large" variant="outline" @click="onCancel()">
                    {{ cancelText }}
                </CButton>
                <CButton class="w-1/2 uppercase" size="large" :variant="confirmVariant" @click="onConfirm()">
                    {{ confirmText }}
                </CButton>
            </div>
        </template>
    </ActionModal>
</template>

<script setup lang="ts">
const props = withDefaults(
    defineProps<{
        title?: string
        message?: string
        confirmText?: string
        cancelText?: string
        confirmVariant?: 'primary' | 'success' | 'decline'
    }>(),
    {
        title: 'Potvrdenie',
        message: 'Ste si istí, že chcete pokračovať?',
        confirmText: 'Potvrdiť',
        cancelText: 'Zrušiť',
        confirmVariant: 'primary'
    }
)

const emit = defineEmits(['close'])

const onConfirm = () => {
    close(true)
}

const onCancel = () => {
    close(false)
}

const close = (value = false) => {
    emit('close', value)
}
</script>
